import { useState } from "react";

import styled from "styled-components";
import { message, Form, Radio } from "antd";
// import { Space } from "antd";
import { GlassCard } from "components/App/styled";
import colors from "constants/palette";

export default function DataController() {
  const [form] = Form.useForm();

  const [type, setType] = useState(0);

  return (
    <Container>
      <Form.Item
        name="filter"
        rules={[
          {
            required: true,
            message: "لطفا فیلتر را وارد کنید!",
          },
        ]}
      >
        <label>بر اساس : </label>
        <label>وضعیت</label>
      </Form.Item>
    </Container>
  );
}
const Container = styled.div``;
const Section = styled.div``;
